import { render, staticRenderFns } from "./carouselList.vue?vue&type=template&id=007f5eb3&"
import script from "./carouselList.vue?vue&type=script&lang=js&"
export * from "./carouselList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\scratch\\runner\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('007f5eb3', component.options)
    } else {
      api.reload('007f5eb3', component.options)
    }
    module.hot.accept("./carouselList.vue?vue&type=template&id=007f5eb3&", function () {
      api.rerender('007f5eb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/SearchNx/Scripts/ListTemplates/carouselList.vue"
export default component.exports